import { Box, Paper } from '@mui/material'
import { useThemeMode } from '../../../theme'

export const TodaySection = ({ title, action, onHeaderClick, children }) => {
  const { palette } = useThemeMode()

  return (
    <Box>
      <Box
        onClick={onHeaderClick}
        sx={{
          backgroundColor: palette.headerColor,
          color: palette.paperColor,
          padding: '10px',
          fontWeight: 600,
          fontSize: '0.9rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: onHeaderClick ? 'pointer' : 'default'
        }}
      >
        {title}
        {action}
      </Box>
      <Paper elevation={2} sx={{ borderRadius: 0 }}>
        {children}
      </Paper>
    </Box>
  )
}
